import { Component } from '@angular/core';
import { topCategories } from '../../../data/dashboard/e-commerce';

@Component({
	selector: 'app-top-selling-products',
	templateUrl: './top-selling-products.component.html',
	styleUrls: ['./top-selling-products.component.scss']
})
export class TopSellingProductsComponent {
	public topProducts = topCategories;
}
